import configureAxios from 'configure/axios';

const axios = configureAxios();

export const fetchAll = (subId) => axios.get('quick/plans/',  { params: { subscription_id: subId } });
export const find = (id) => axios.get(`quick/plans/${id}/`);
